// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body.research-page {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: 100vh;
  height: 100dvh;
  max-width: 100%;
}

html.research-page {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: 100vh;
  height: 100dvh;
  max-width: 100%;
}

.research-sidenav {
  overflow: hidden !important;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
}
.research-sidenav .navbar .navbar__brand {
  display: none !important;
}
@media (min-width: 768px) {
  .research-sidenav .navbar {
    padding-left: 42px;
  }
}
@media (min-width: 1200px) {
  .research-sidenav .navbar {
    padding-right: 50px;
  }
}

.research {
  flex: 1 1;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: hidden;
}
.research .executive-summary {
  display: inline-flex;
  flex-flow: column;
}
.research .executive-summary .executive-summary-content {
  margin-top: 30px;
  margin-bottom: 10px;
}
.research .executive-summary .executive-summary-content .executive-summary-title {
  display: block;
  margin-bottom: 20px;
  color: var(--primary-color-dark-500);
}
.research .executive-summary .executive-summary-content p {
  color: var(--primary-color-dark-500);
}
.research .executive-summary .executive-summary-content ul {
  color: var(--primary-color-dark-300);
}
.research__head__title {
  color: var(--primary-color-dark-700);
  font-family: var(--primary-font);
  font-size: 35px;
  font-weight: 950;
  letter-spacing: 0;
  line-height: 41px;
  margin-top: 35px;
}
.research__head__subtitle {
  color: rgba(0, 0, 0, 0.38);
  font-family: var(--primary-font);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 5px;
}
.research__filter {
  width: 100%;
  border-radius: 30px;
  background-color: var(--primary-color-light-500);
  box-shadow: 2px 2px 6px 1px rgba(255, 255, 255, 0.17);
  padding: 5px 10px;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  justify-content: flex-end;
}
@media (min-width: 1200px) {
  .research__filter {
    display: none;
  }
}
.research__form {
  height: 100%;
  width: 100%;
  border-radius: 30px;
  background-color: var(--primary-color-light-500);
  box-shadow: 2px 2px 6px 1px rgba(255, 255, 255, 0.17);
  white-space: pre-wrap;
  display: flex;
  flex-flow: column;
  padding: 0px 50px 30px 50px;
}
@media screen and (max-width: 768px) {
  .research__form {
    padding: 0px 15px 30px 15px;
  }
}
@media screen and (max-width: 480px) {
  .research__form {
    padding: 0px 10px 30px 10px;
  }
}
.research__form .company-input {
  margin-top: 20px;
}
.research__form * + * {
  margin-top: 0;
}
.research__form__button {
  border-radius: 20px;
  background-color: var(--primary-color-600);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: 1px solid var(--primary-color-600);
  color: var(--primary-color-light-500);
  font-family: var(--tertiary-font);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  padding: 10px 20px;
  margin-top: 20px;
}
@media (min-width: 992px) {
  .research__form__button {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 25px;
  }
}
.research__form__button:hover, .research__form__button:focus {
  background-color: var(--primary-color-light-500);
  border: 1px solid var(--primary-color-600);
  color: var(--primary-color-600);
  transition: 0.4s;
}
.research__form__header {
  display: flex;
  flex-direction: row !important;
  flex-flow: row wrap;
  flex-shrink: 0;
}
.research__form__header > div {
  box-sizing: border-box;
}
.research__form__header textarea,
.research__form__header select {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #464646;
  border-radius: 2px;
  background-color: var(--primary-color-light-500);
  color: var(--primary-color-dark-700);
  padding: 8px 12px;
  height: 38px;
  font-size: 14px;
  line-height: 18px;
  outline: none;
  box-shadow: none;
}
.research__form__header textarea {
  resize: none;
  min-height: 38px;
}
.research__form__header textarea:focus,
.research__form__header select:focus {
  border-color: var(--primary-color-600);
}
.research__form__checkboxes {
  position: relative;
  width: -webkit-fit-content;
  width: fit-content;
  min-width: 330px;
  block-size: -webkit-fit-content;
  block-size: fit-content;
  padding: 0 0 0 0;
  border-radius: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
  flex-direction: row !important;
  vertical-align: top;
  flex-flow: row wrap;
  align-items: center;
  grid-gap: 10px;
  gap: 10px;
  display: grid !important;
  grid-auto-flow: column;
}
@media screen and (max-width: 426px) {
  .research__form__checkboxes {
    margin-right: 0;
  }
}
.research__form__checkbox {
  float: left;
}
.research__form__checkbox select {
  width: 100%;
}
.research__form__checkbox .a-circle-checkbox {
  margin: 2px 0 1% !important;
}
.research__form__option {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
.research__form__history-input {
  float: left;
  margin: 0 15px 10px 15px;
  border-radius: 10px;
  border: 1px solid #e4e4e7;
  padding: 8px 12px 8px 12px;
  cursor: pointer;
}
.research__form__history-container {
  flex-grow: 1;
  flex: 1 1;
  min-height: 0;
  margin: 15px 0 15px -70px;
  overflow-y: auto;
  overflow-x: clip;
  padding-right: 20px;
  padding-left: 70px;
  max-width: calc(100% + 70px);
}
@media screen and (max-width: 768px) {
  .research__form__history-container {
    margin: 15px 0 15px -20px;
    padding-left: 20px;
    padding-right: 15px;
    max-width: calc(100% + 20px);
  }
}
@media screen and (max-width: 480px) {
  .research__form__history-container {
    margin: 15px 0 15px -5px;
    padding-left: 8px;
    padding-right: 16px;
    max-width: calc(100% + 5px);
  }
}
.research__form__history-container a {
  border-color: var(--accent-color-1);
  color: var(--accent-color-1);
}
.research__form__history-container a:hover {
  opacity: 0.7;
}
.research__form__history-container table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  word-wrap: break-word;
  overflow-wrap: break-word;
  border-collapse: collapse;
}
.research__form__history-container table th,
.research__form__history-container table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  vertical-align: top;
}
@media screen and (max-width: 768px) {
  .research__form__history-container table {
    font-size: 0.8em;
  }
  .research__form__history-container table th,
  .research__form__history-container table td {
    padding: 3px 4px;
  }
}
@media screen and (max-width: 480px) {
  .research__form__history-container table {
    font-size: 0.7em;
  }
  .research__form__history-container table th,
  .research__form__history-container table td {
    padding: 2px 3px;
  }
}
.research__form__history-container img {
  max-width: 100%;
  height: auto;
}
.research__form__history-container pre,
.research__form__history-container code {
  max-width: 100%;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.research__form__input-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.research__form__presentation-button-group {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: clamp(160px, 24vw, 200px);
  max-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.research__form__presentation-button-group .ui-dropdown {
  width: 100%;
  min-width: 100%;
  display: flex;
  align-items: center;
}
.research__form__presentation-button-group .ui-dropdown-button {
  padding: 4px 8px;
  font-size: 0.875rem;
  height: auto;
  min-height: 28px;
  line-height: 1.2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.research__form__presentation-button-group .ui-dropdown-menu {
  left: 0 !important;
  right: auto !important;
  min-width: 100% !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  transform-origin: top left !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 0 !important;
}
.research__form__presentation-button-group .ui-dropdown-menu__item {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.research__form__presentation-button-group .ui-dropdown-menu.align-right {
  left: auto !important;
  right: 0 !important;
  transform-origin: top right !important;
}
@media screen and (max-width: 768px) {
  .research__form__presentation-button-group {
    left: 10px;
    width: auto;
    max-width: none;
  }
  .research__form__presentation-button-group .ui-dropdown {
    min-width: auto;
  }
  .research__form__presentation-button-group .ui-dropdown-menu {
    min-width: 100px !important;
    width: -webkit-max-content !important;
    width: max-content !important;
    max-width: none !important;
  }
  .research__form__presentation-button-group .ui-dropdown-button {
    padding: 3px 6px;
    font-size: 0.8rem;
    min-height: 24px;
  }
}
.research__form__icon {
  position: absolute;
  right: 30px;
  cursor: pointer;
  height: 24px;
}
.research__form__icon--enhance {
  right: 65px;
  color: var(--accent-color-1);
}
.research__form__icon--loading {
  cursor: default;
  opacity: 0.5;
  pointer-events: none;
}
.research__form__input {
  resize: none;
  border-radius: 0 0 10px 10px;
  padding-right: 50px;
  padding-left: 15px;
}
.research__form__input-container.has-presentation-button .research__form__input {
  padding-left: 60px;
}
.research__form__autocomplete {
  border-radius: 10px;
  padding: 5px 15px;
  color: var(--primary-color-600);
  cursor: pointer;
}
.research__form__autocomplete:hover {
  background-color: var(--primary-color-light-200);
}
.research__form__autocomplete-box {
  position: absolute;
  bottom: 100%;
  width: 100%;
  left: 0;
  background-color: var(--primary-color-light-500);
  border: 2px solid #464646;
  border-radius: 10px 10px 0 0;
  border-bottom: 0;
  z-index: var(--z-index-popup-light);
  max-height: 500px;
  overflow-y: auto;
}
.research__form__history {
  position: relative;
  border-radius: 10px;
  padding: 5px 15px;
  cursor: pointer;
}
.research__form__history:hover {
  background-color: var(--primary-color-light-200);
}
@media screen and (max-width: 425px) {
  .research__form__history__button {
    width: 36px !important;
    height: 36px !important;
    min-height: 36px;
    border-radius: 50%;
    padding: 0;
  }
  .research__form__history__button .ui-button__text {
    display: none;
  }
}
@media screen and (max-width: 425px) {
  .research__form__history__button .research__form__history__button-text {
    display: none;
  }
}
.research__form__user {
  width: 100%;
  padding: 15px 15px;
  margin-left: auto;
  border-width: 1;
  border-radius: 10px;
  display: inline-block !important;
}
.research__form__followup-box {
  display: inline-block !important;
  vertical-align: top;
  max-width: 50%;
  float: right;
  margin-left: auto;
  color: var(--primary-color-500);
}
.research__form__followup_desc {
  margin-bottom: 10px;
  width: -webkit-fit-content;
  width: fit-content;
  padding: 5px 10px;
  margin-left: auto;
  margin-left: 15px;
}
.research__form__followup {
  margin-bottom: 10px;
  width: -webkit-fit-content;
  width: fit-content;
  padding: 5px 10px;
  margin-left: auto;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #ececf1;
  background-color: var(--primary-color-light-500);
  margin-left: 15px;
}
.research__form__followup:hover {
  background-color: var(--primary-color-light-200);
  color: var(--primary-color-500);
}
.research__form__followup-category {
  width: -webkit-fit-content;
  width: fit-content;
}
.research__form__followup-category-title {
  padding: 5px 10px;
  margin-bottom: 10px;
}
.research__form__assistant {
  width: 100%;
  padding: 15px 15px;
  border-width: 1;
  border-radius: 10px;
  margin-bottom: 15px;
  display: block !important;
}
.research__form__message {
  display: block !important;
  padding-left: 45px;
  max-width: 100%;
  overflow-x: hidden;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
@media screen and (max-width: 768px) {
  .research__form__message {
    padding-left: 0;
  }
}
.research__form__message img {
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: pointer;
  max-width: 100%;
  height: auto;
  min-height: 200px;
  object-fit: contain;
  contain: layout;
}
.research__form__message img:hover {
  opacity: 0.9;
}
.research__form__message img[width], .research__form__message img[height] {
  min-height: auto;
}
.research__form__message h1,
.research__form__message h2,
.research__form__message h3,
.research__form__message h4,
.research__form__message h5,
.research__form__message h6 {
  font-weight: inherit;
}
.research__form__message table {
  max-width: 100%;
  width: 100%;
  table-layout: fixed;
  word-wrap: break-word;
  overflow-wrap: break-word;
  border-collapse: collapse;
}
.research__form__message table th,
.research__form__message table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  vertical-align: top;
  padding: 4px 6px;
}
@media screen and (max-width: 768px) {
  .research__form__message table {
    font-size: 0.8em;
  }
  .research__form__message table th,
  .research__form__message table td {
    padding: 3px 4px;
  }
}
@media screen and (max-width: 480px) {
  .research__form__message table {
    font-size: 0.7em;
  }
  .research__form__message table th,
  .research__form__message table td {
    padding: 2px 3px;
  }
}
.research__form__row {
  display: block !important;
}
.research__form__description {
  display: inline-block !important;
  background-color: var(--primary-color-light-200);
  color: var(--primary-color-500);
  border-radius: 10px;
  padding: 25px;
  vertical-align: top;
  width: -webkit-fit-content;
  width: fit-content;
  max-width: 50%;
}
.research__form__short-description {
  display: inline-block !important;
  padding: 25px;
  color: var(--primary-color-500);
}
.research__form__speaker {
  display: inline-block !important;
  font-weight: bold;
  padding-left: 12px;
  vertical-align: middle;
}
.research__form__typing {
  display: block !important;
  width: -webkit-fit-content;
  width: fit-content;
  padding: 15px 20px;
  border-width: 1;
  border-radius: 10px;
  background-color: var(--primary-color-light-200);
  min-height: 52px;
  float: left;
}
.research__form__expand {
  padding-bottom: 15px;
  padding-left: 45px;
  border-width: 1;
  border-radius: 10px;
  flex-direction: row !important;
}
.research__form__expand button {
  margin-right: 20px;
  margin-top: 30px;
}
.research__form button:not(.ui-button) {
  border-radius: 10px;
  float: right;
}
.research__form__image {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  display: inline-flex !important;
  vertical-align: middle;
  justify-content: center;
}
.research__form__image img {
  display: inline-block !important;
  width: 31px;
  height: auto;
  object-fit: contain;
}
.research__table {
  width: 100%;
}
@media (min-width: 1200px) {
  .research__table {
    background-color: var(--primary-color-light-500);
    border-radius: 30px;
    padding: 30px 30px;
    margin-bottom: 100px;
  }
}
.research__footer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  padding: 30px 30px;
  bottom: 0;
}
.research__footer__content {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  padding: 10px 20px;
  background-color: var(--primary-color-light-500);
  box-shadow: 2px 2px 6px 1px rgba(0, 0, 0, 0.17);
  font-size: 14px;
  font-weight: 500;
}
@media (min-width: 992px) {
  .research__footer__content {
    font-size: 18px;
  }
}
.research__footer__content span {
  background-color: var(--accent-color-1);
  color: var(--primary-color-light-500);
  font-size: 16px;
  font-weight: 500;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.research__footer__button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background-color: var(--primary-color-600);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: 1px solid var(--primary-color-600);
  color: var(--primary-color-light-500);
  font-family: var(--tertiary-font);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  padding: 10px 20px;
  margin-left: 10px;
  margin-top: 0;
}
@media (min-width: 992px) {
  .research__footer__button {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 25px;
  }
}
.research__footer__button:hover, .research__footer__button:focus {
  background-color: var(--primary-color-light-500);
  border: 1px solid var(--primary-color-600);
  color: var(--primary-color-600);
  transition: 0.4s;
}
.research__footer__button i {
  margin-left: 5px;
  font-size: 20px;
}
.research__checkbox {
  margin-top: 8px;
}
.research .typing-message {
  width: -webkit-fit-content;
  width: fit-content;
  display: inline-block !important;
  vertical-align: middle;
}
.research .typing-message--pinned {
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.85;
}
.research .typing {
  position: relative;
  margin-left: 10px;
  width: 42px;
  display: inline-flex !important;
  font-weight: bold;
  vertical-align: middle;
  height: 24px;
  align-items: center;
}
.research .typing span {
  content: "";
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
  height: 8px;
  width: 8px;
  background: #3b5998;
  position: absolute;
  left: 0;
  border-radius: 50%;
}
.research .typing span:nth-child(2) {
  animation-delay: 0.2s;
  margin-left: 12px;
}
.research .typing span:nth-child(3) {
  animation-delay: 0.4s;
  margin-left: 24px;
}
@keyframes blink {
  0% {
    opacity: 0.1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}
.research input::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
.research .data-source {
  overflow: auto;
  max-height: 300px;
  margin: 20px 30px;
  padding: 5px 10px;
  border: 1px solid var(--primary-color-600);
}
.research .data-source .data-source__copy {
  position: absolute;
  top: 6px;
  right: 10px;
  z-index: 1;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--primary-color-600);
  background: #fff;
  border: 1px solid var(--primary-color-600);
  border-radius: 4px;
  cursor: pointer;
}
.research .data-source .data-source__copy:hover {
  background: var(--primary-color-600);
  color: #fff;
}

input[type=date] {
  font-size: 14px;
  width: 130px;
  padding-right: 0px;
  padding-left: 40px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-width: 0px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  caret-color: transparent;
}
@media screen and (max-width: 426px) {
  input[type=date] {
    max-width: 45px;
  }
}

input[type=date]::-webkit-calendar-picker-indicator {
  width: 0px;
}

input::-webkit-datetime-edit-year-field:focus {
  background-color: transparent;
  color: #323232;
}

input::-webkit-datetime-edit-month-field:focus {
  background-color: transparent;
  color: #323232;
}

input::-webkit-datetime-edit-day-field:focus {
  background-color: transparent;
  color: #323232;
}

.half-empty {
  height: 8px;
}

.typing-message-wrapper {
  display: flex;
  flex-flow: row;
  align-items: center;
  margin-bottom: 100px;
  padding-left: 65px;
}

.presentation-slide {
  margin-bottom: 4px;
}
.presentation-slide h2 {
  color: var(--primary-color-dark-900);
  margin-bottom: 15px;
  font-size: 1.5rem;
}
.presentation-slide .slide-content {
  margin-bottom: 4px;
  line-height: 1.6;
}
.presentation-slide .slide-content:last-child,
.presentation-slide .slide-content p:last-child {
  margin-bottom: 0 !important;
}
.presentation-slide .slide-visual-section {
  background-color: var(--background-color-light);
  border-radius: 8px;
  padding: 16px;
  margin-top: 10px;
}
.presentation-slide .slide-visual-section h3 {
  color: var(--primary-color-500);
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.research--share .chat-content:has(.download-presentation-btn) {
  overflow-x: visible;
}

.slide-visual-suggestion img {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  min-height: 200px;
  object-fit: contain;
  contain: layout;
}
.slide-visual-suggestion img:hover {
  opacity: 0.9;
}
.slide-visual-suggestion .visual-analysis {
  margin-top: 15px;
}
.slide-visual-suggestion .visual-analysis p {
  margin-bottom: 12px;
  line-height: 1.5;
}
.slide-visual-suggestion .visual-analysis p strong {
  color: var(--primary-color-dark-900);
  display: block;
  margin-bottom: 5px;
}
.slide-visual-suggestion .visual-analysis .visual-source {
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  margin-top: 10px;
}
.slide-visual-suggestion .visual-analysis .visual-source a {
  color: var(--primary-color-500);
  text-decoration: none;
}
.slide-visual-suggestion .visual-analysis .visual-source a:hover {
  text-decoration: underline;
}

.sidenav.share-layout {
  overflow-y: hidden !important;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.inline-chart-container {
  position: relative;
  margin: 20px 0;
  padding: 15px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border-left: 4px solid #4a90d9;
  border-left: 4px solid var(--primary-color-500, #4a90d9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  contain: layout style;
  min-height: 250px;
}
.inline-chart-container[data-hidden=true] {
  display: none !important;
}
.inline-chart-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.inline-chart-container img.inline-report-chart {
  max-height: 400px;
  max-width: 100%;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: block;
}
.inline-chart-container img.inline-report-chart:hover {
  opacity: 0.9;
}
.inline-chart-container .inline-chart-analysis {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  color: var(--primary-color-dark-700, #333);
}
.inline-chart-container .inline-chart-analysis p {
  margin: 8px 0;
}
.inline-chart-container .inline-chart-analysis p strong {
  color: #1a1a1a;
  color: var(--primary-color-dark-900, #1a1a1a);
  display: block;
  margin-bottom: 4px;
}
.inline-chart-container .inline-chart-analysis a {
  color: #4a90d9;
  color: var(--primary-color-500, #4a90d9);
  text-decoration: none;
}
.inline-chart-container .inline-chart-analysis a:hover {
  text-decoration: underline;
}
.inline-chart-container .delete-chart-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 11px;
  z-index: 10;
}
.inline-chart-container .delete-chart-btn:hover {
  background: rgba(0, 0, 0, 0.7);
}
@media screen and (max-width: 768px) {
  .inline-chart-container {
    padding: 12px;
    margin: 15px 0;
  }
  .inline-chart-container img.inline-report-chart {
    max-height: 300px;
  }
  .inline-chart-container .inline-chart-analysis {
    font-size: 13px;
  }
  .inline-chart-container .delete-chart-btn {
    opacity: 1;
  }
}
@media screen and (max-width: 480px) {
  .inline-chart-container {
    padding: 10px;
    margin: 12px 0;
    border-radius: 8px;
  }
  .inline-chart-container img.inline-report-chart {
    max-height: 250px;
    margin-bottom: 8px;
  }
  .inline-chart-container .inline-chart-analysis {
    font-size: 12px;
  }
  .inline-chart-container .inline-chart-analysis p {
    margin: 6px 0;
  }
}

.share-layout .delete-chart-btn {
  display: none !important;
}

.trusted-sources-footer {
  margin-top: 24px;
  padding: 20px 24px;
  background: linear-gradient(to right, rgba(59, 130, 246, 0.08), rgba(59, 130, 246, 0.02));
  border-left: 4px solid #3b82f6;
  border-radius: 12px;
  font-family: var(--primary-font);
  color: #1e293b;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  width: -webkit-fit-content;
  width: fit-content;
  max-width: 100%;
}
@media screen and (max-width: 480px) {
  .trusted-sources-footer {
    padding: 15px 16px;
  }
}
.trusted-sources-footer .trusted-sources-header {
  font-weight: 700;
  font-size: 1.1em;
  margin-bottom: 14px;
  color: #0f172a;
  position: relative;
  padding-left: 32px;
  line-height: 1.5;
}
.trusted-sources-footer .trusted-sources-header::before {
  content: "✓";
  position: absolute;
  left: 0;
  top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: #3b82f6;
  color: white;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 900;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}
.trusted-sources-footer .trusted-sources-list {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}
.trusted-sources-footer .trusted-sources-list li {
  position: relative;
  padding-left: 32px;
  margin-bottom: 10px;
  line-height: 1.6;
  font-size: 0.95em;
  color: #334155;
}
.trusted-sources-footer .trusted-sources-list li::before {
  content: "•";
  color: #60a5fa;
  font-weight: bold;
  font-size: 1.2em;
  position: absolute;
  left: 10px;
  top: -1px;
}
.trusted-sources-footer .trusted-sources-list li:last-child {
  margin-bottom: 0;
}
.trusted-sources-footer .trusted-sources-list li a {
  color: #2563eb;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.15s ease;
  border-bottom: 1px dotted rgba(37, 99, 235, 0.3);
}
.trusted-sources-footer .trusted-sources-list li a:hover {
  color: #1e40af;
  text-decoration: none;
  border-bottom: 1px solid #1e40af;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/Research.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,6BAAA;EACA,6BAAA;EACA,aAAA;EAEA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,6BAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,2BAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAAF;AAKI;EACE,wBAAA;AAHN;AAOI;EARF;IASI,kBAAA;EAJJ;AACF;AAMI;EAZF;IAaI,mBAAA;EAHJ;AACF;;AAOA;EAEE,SAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AALF;AAOE;EACE,oBAAA;EACA,iBAAA;AALJ;AAOI;EACE,gBAAA;EACA,mBAAA;AALN;AAOM;EACE,cAAA;EACA,mBAAA;EACA,oCAAA;AALR;AAQM;EACE,oCAAA;AANR;AASM;EACE,oCAAA;AAPR;AAcI;EACE,oCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAZN;AAeI;EACE,0BAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAbN;AAiBE;EACE,WAAA;EACA,mBAAA;EACA,gDAAA;EACA,qDAAA;EACA,iBAAA;EAMA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AApBJ;AAaI;EAPF;IAQI,aAAA;EAVJ;AACF;AAkBE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gDAAA;EACA,qDAAA;EAEA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;AAjBJ;AAmBI;EAZF;IAaI,2BAAA;EAhBJ;AACF;AAkBI;EAhBF;IAiBI,2BAAA;EAfJ;AACF;AAiBI;EACE,gBAAA;AAfN;AAkBI;EACE,aAAA;AAhBN;AAmBI;EACE,mBAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAjBN;AAmBM;EAdF;IAeI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;EAhBN;AACF;AAkBM;EAEE,gDAAA;EACA,0CAAA;EACA,+BAAA;EACA,gBAAA;AAjBR;AAqBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AAnBN;AAqBM;EACE,sBAAA;AAnBR;AAsBM;;EAEE,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;EACA,oCAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AApBR;AAuBM;EACE,YAAA;EACA,gBAAA;AArBR;AAwBM;;EAEE,sCAAA;AAtBR;AA0BI;EACE,kBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,gBAAA;EACA,+BAAA;EAAA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EAAA,SAAA;EACA,wBAAA;EACA,sBAAA;AAxBN;AA0BM;EAjBF;IAkBI,eAAA;EAvBN;AACF;AA0BI;EACE,WAAA;AAxBN;AA0BM;EACE,WAAA;AAxBR;AA2BM;EACE,2BAAA;AAzBR;AA6BI;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AA3BN;AA8BI;EACE,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AA5BN;AA+BI;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;AA7BN;AAgCM;EAZF;IAaI,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,4BAAA;EA7BN;AACF;AA+BM;EAnBF;IAoBI,wBAAA;IACA,iBAAA;IACA,mBAAA;IACA,2BAAA;EA5BN;AACF;AA8BM;EACE,mCAAA;EACA,4BAAA;AA5BR;AA8BQ;EACE,YAAA;AA5BV;AAiCM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AA/BR;AAiCQ;;EAEE,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AA/BV;AAmCQ;EAjBF;IAkBI,gBAAA;EAhCR;EAkCQ;;IAEE,gBAAA;EAhCV;AACF;AAmCQ;EA1BF;IA2BI,gBAAA;EAhCR;EAkCQ;;IAEE,gBAAA;EAhCV;AACF;AAoCM;EACE,eAAA;EACA,YAAA;AAlCR;AAqCM;;EAEE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAnCR;AAuCI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AArCN;AAwCI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtCN;AAyCM;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAvCR;AA0CM;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxCR;AA2CM;EACE,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,sBAAA;EACA,0BAAA;EACA,iCAAA;EACA,qCAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;AAzCR;AA2CQ;EACE,6BAAA;EACA,8BAAA;AAzCV;AA4CQ;EACE,qBAAA;EACA,mBAAA;EACA,sCAAA;AA1CV;AA8CM;EAxDF;IAyDI,UAAA;IACA,WAAA;IACA,eAAA;EA3CN;EA6CM;IACE,eAAA;EA3CR;EA8CM;IACE,2BAAA;IACA,qCAAA;IAAA,6BAAA;IACA,0BAAA;EA5CR;EA+CM;IACE,gBAAA;IACA,iBAAA;IACA,gBAAA;EA7CR;AACF;AAiDI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA/CN;AAkDI;EACE,WAAA;EACA,4BAAA;AAhDN;AAmDI;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AAjDN;AAoDI;EACE,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AAlDN;AAsDM;EAGE,kBAAA;AAtDR;AA0DI;EACE,mBAAA;EACA,iBAAA;EAMA,+BAAA;EACA,eAAA;AA7DN;AAwDM;EACE,gDAAA;AAtDR;AA6DI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,gDAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,gBAAA;AA3DN;AA8DI;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA5DN;AA8DM;EACE,gDAAA;AA5DR;AAgEQ;EADF;IAEI,sBAAA;IACA,uBAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;EA7DR;EA+DQ;IACE,aAAA;EA7DV;AACF;AAiEU;EADF;IAEI,aAAA;EA9DV;AACF;AAmEI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AAjEN;AAoEI;EACE,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AAlEN;AAqEI;EACE,mBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAnEN;AAsEI;EACE,mBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gDAAA;EACA,iBAAA;AArEN;AAuEM;EACE,gDAAA;EACA,+BAAA;AArER;AAyEI;EACE,0BAAA;EAAA,kBAAA;AAvEN;AAyEM;EACE,iBAAA;EACA,mBAAA;AAvER;AA2EI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAzEN;AA4EI;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AA1EN;AA4EM;EARF;IASI,eAAA;EAzEN;AACF;AA4EM;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EAEA,iBAAA;EACA,mBAAA;EACA,eAAA;AA3ER;AA6EQ;EACE,YAAA;AA3EV;AA+EQ;EAEE,gBAAA;AA9EV;AAkFM;;;;;;EAME,oBAAA;AAhFR;AAoFM;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AAlFR;AAoFQ;;EAEE,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAlFV;AAqFQ;EAjBF;IAkBI,gBAAA;EAlFR;EAoFQ;;IAEE,gBAAA;EAlFV;AACF;AAqFQ;EA1BF;IA2BI,gBAAA;EAlFR;EAoFQ;;IAEE,gBAAA;EAlFV;AACF;AAuFI;EACE,yBAAA;AArFN;AAwFI;EACE,gCAAA;EACA,gDAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,cAAA;AAtFN;AAyFI;EACE,gCAAA;EACA,aAAA;EACA,+BAAA;AAvFN;AA0FI;EACE,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAxFN;AA2FI;EACE,yBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,WAAA;AAzFN;AA4FI;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AA1FN;AA4FM;EACE,kBAAA;EACA,gBAAA;AA1FR;AA8FI;EACE,mBAAA;EACA,YAAA;AA5FN;AA+FI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;AA7FN;AA+FM;EACE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA7FR;AAkGE;EACE,WAAA;AAhGJ;AAkGI;EAHF;IAII,gDAAA;IACA,mBAAA;IACA,kBAAA;IACA,oBAAA;EA/FJ;AACF;AAkGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AAhGJ;AAkGI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,eAAA;EACA,gBAAA;AAhGN;AAkGM;EAXF;IAYI,eAAA;EA/FN;AACF;AAiGM;EACE,uCAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA/FR;AAmGI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;AAjGN;AAmGM;EAlBF;IAmBI,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;EAhGN;AACF;AAkGM;EAEE,gDAAA;EACA,0CAAA;EACA,+BAAA;EACA,gBAAA;AAjGR;AAoGM;EACE,gBAAA;EACA,eAAA;AAlGR;AAuGE;EACE,eAAA;AArGJ;AA4GE;EACE,0BAAA;EAAA,kBAAA;EACA,gCAAA;EACA,sBAAA;AA1GJ;AA6GE;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;AA3GJ;AA8GE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,iBAAA;EAEA,sBAAA;EACA,YAAA;EACA,mBAAA;AA7GJ;AA+GI;EACE,WAAA;EACA,8BAAA;EACA,yBAAA;EACA,WA/BQ;EAgCR,UAhCQ;EAiCR,mBAhCQ;EAiCR,kBAAA;EACA,OAAA;EACA,kBAAA;AA7GN;AA+GM;EACE,qBAAA;EACA,iBAAA;AA7GR;AAgHM;EACE,qBAAA;EACA,iBAAA;AA9GR;AAmHE;EACE;IACE,YAAA;EAjHJ;EAoHE;IACE,UAAA;EAlHJ;EAqHE;IACE,YAAA;EAnHJ;AACF;AAsHE;EACE,eAAA;AApHJ;AAuHE;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0CAAA;AArHJ;AAuHI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;AArHN;AAuHM;EACE,oCAAA;EACA,WAAA;AArHR;;AA4HA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;AAzHF;AA2HE;EAfF;IAgBI,eAAA;EAxHF;AACF;;AA2HA;EACE,UAAA;AAxHF;;AA2HA;EACE,6BAAA;EACA,cAAA;AAxHF;;AA2HA;EACE,6BAAA;EACA,cAAA;AAxHF;;AA2HA;EACE,6BAAA;EACA,cAAA;AAxHF;;AA2HA;EACE,WAAA;AAxHF;;AA2HA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAxHF;;AA2HA;EACE,kBAAA;AAxHF;AA0HE;EACE,oCAAA;EACA,mBAAA;EACA,iBAAA;AAxHJ;AA2HE;EACE,kBAAA;EACA,gBAAA;AAzHJ;AA2HI;;EAEE,2BAAA;AAzHN;AA6HE;EACE,+CAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA3HJ;AA6HI;EACE,+BAAA;EACA,mBAAA;EACA,iBAAA;AA3HN;;AA2IA;EACE,mBAAA;AAxIF;;AA4IE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EAEA,iBAAA;EACA,mBAAA;EACA,eAAA;AA1IJ;AA4II;EACE,YAAA;AA1IN;AA8IE;EACE,gBAAA;AA5IJ;AA8II;EACE,mBAAA;EACA,gBAAA;AA5IN;AA8IM;EACE,oCAAA;EACA,cAAA;EACA,kBAAA;AA5IR;AAgJI;EACE,iBAAA;EACA,kCAAA;EACA,gBAAA;AA9IN;AAgJM;EACE,+BAAA;EACA,qBAAA;AA9IR;AAgJQ;EACE,0BAAA;AA9IV;;AAqJA;EACE,6BAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAlJF;;AAsJA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,8BAAA;EAAA,wDAAA;EACA,yCAAA;EAEA,qBAAA;EAEA,iBAAA;AArJF;AAwJE;EACE,wBAAA;AAtJJ;AAyJE;EACE,0CAAA;AAvJJ;AA0JE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;EACA,cAAA;AAxJJ;AA0JI;EACE,YAAA;AAxJN;AA4JE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EAAA,0CAAA;AA1JJ;AA4JI;EACE,aAAA;AA1JN;AA4JM;EACE,cAAA;EAAA,6CAAA;EACA,cAAA;EACA,kBAAA;AA1JR;AA8JI;EACE,cAAA;EAAA,wCAAA;EACA,qBAAA;AA5JN;AA8JM;EACE,0BAAA;AA5JR;AAiKE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AA/JJ;AAiKI;EACE,8BAAA;AA/JN;AAoKE;EAhFF;IAiFI,aAAA;IACA,cAAA;EAjKF;EAmKE;IACE,iBAAA;EAjKJ;EAoKE;IACE,eAAA;EAlKJ;EAqKE;IACE,UAAA;EAnKJ;AACF;AAsKE;EAjGF;IAkGI,aAAA;IACA,cAAA;IACA,kBAAA;EAnKF;EAqKE;IACE,iBAAA;IACA,kBAAA;EAnKJ;EAsKE;IACE,eAAA;EApKJ;EAsKI;IACE,aAAA;EApKN;AACF;;AA2KE;EACE,wBAAA;AAxKJ;;AA4KA;EACE,gBAAA;EACA,kBAAA;EACA,yFAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,kFAAA;EACA,0BAAA;EAAA,kBAAA;EACA,eAAA;AAzKF;AA2KE;EAZF;IAaI,kBAAA;EAxKF;AACF;AA0KE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAxKJ;AA0KI;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;AAxKN;AA4KE;EACE,qBAAA;EACA,eAAA;EACA,SAAA;AA1KJ;AA4KI;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA1KN;AA4KM;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AA1KR;AA6KM;EACE,gBAAA;AA3KR;AA8KM;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gDAAA;AA5KR;AA8KQ;EACE,cAAA;EACA,qBAAA;EACA,gCAAA;AA5KV","sourcesContent":["// Disable body scroll for research page\nbody.research-page {\n  overflow-y: hidden !important;\n  overflow-x: hidden !important;\n  height: 100vh;\n  // Use dynamic viewport height for mobile browsers to account for address bars\n  height: 100dvh;\n  max-width: 100%;\n}\n\nhtml.research-page {\n  overflow-y: hidden !important;\n  overflow-x: hidden !important;\n  height: 100vh;\n  height: 100dvh;\n  max-width: 100%;\n}\n\n.research-sidenav {\n  overflow: hidden !important;\n  height: 100vh;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n\n  .navbar {\n\n    // Hide brand to prevent unwanted spacing\n    .navbar__brand {\n      display: none !important;\n    }\n\n    // Align header items with the content padding (adjusted to 42px to match visual alignment)\n    @media (min-width: 768px) {\n      padding-left: 42px;\n    }\n\n    @media (min-width: 1200px) {\n      padding-right: 50px;\n    }\n  }\n}\n\n.research {\n  // Remove fixed calculation and use flex-grow to fill remaining space\n  flex: 1;\n  height: 100vh; // Constrain to viewport so scrollbar appears\n  height: 100dvh;\n  min-height: 0; // Essential for nested scrolling in flex containers\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n  overflow-y: hidden;\n\n  .executive-summary {\n    display: inline-flex;\n    flex-flow: column;\n\n    .executive-summary-content {\n      margin-top: 30px;\n      margin-bottom: 10px;\n\n      .executive-summary-title {\n        display: block;\n        margin-bottom: 20px;\n        color: var(--primary-color-dark-500);\n      }\n\n      p {\n        color: var(--primary-color-dark-500);\n      }\n\n      ul {\n        color: var(--primary-color-dark-300);\n      }\n\n    }\n  }\n\n  &__head {\n    &__title {\n      color: var(--primary-color-dark-700);\n      font-family: var(--primary-font);\n      font-size: 35px;\n      font-weight: 950;\n      letter-spacing: 0;\n      line-height: 41px;\n      margin-top: 35px;\n    }\n\n    &__subtitle {\n      color: rgba(0, 0, 0, 0.38);\n      font-family: var(--primary-font);\n      font-size: 13px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 16px;\n      margin-top: 5px;\n    }\n  }\n\n  &__filter {\n    width: 100%;\n    border-radius: 30px;\n    background-color: var(--primary-color-light-500);\n    box-shadow: 2px 2px 6px 1px rgba(255, 255, 255, 0.17);\n    padding: 5px 10px;\n\n    @media (min-width: 1200px) {\n      display: none;\n    }\n\n    display: flex;\n    flex-flow: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n\n  &__form {\n    height: 100%;\n    width: 100%;\n    border-radius: 30px;\n    background-color: var(--primary-color-light-500);\n    box-shadow: 2px 2px 6px 1px rgba(255, 255, 255, 0.17);\n\n    white-space: pre-wrap;\n    display: flex;\n    flex-flow: column;\n    padding: 0px 50px 30px 50px;\n\n    @media screen and (max-width: 768px) {\n      padding: 0px 15px 30px 15px;\n    }\n\n    @media screen and (max-width: 480px) {\n      padding: 0px 10px 30px 10px;\n    }\n\n    .company-input {\n      margin-top: 20px;\n    }\n\n    *+* {\n      margin-top: 0;\n    }\n\n    &__button {\n      border-radius: 20px;\n      background-color: var(--primary-color-600);\n      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n      border: 1px solid var(--primary-color-600);\n      color: var(--primary-color-light-500);\n      font-family: var(--tertiary-font);\n      font-size: 14px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 17px;\n      padding: 10px 20px;\n      margin-top: 20px;\n\n      @media (min-width: 992px) {\n        font-size: 20px;\n        font-weight: 500;\n        letter-spacing: 0;\n        line-height: 25px;\n      }\n\n      &:hover,\n      &:focus {\n        background-color: var(--primary-color-light-500);\n        border: 1px solid var(--primary-color-600);\n        color: var(--primary-color-600);\n        transition: .4s;\n      }\n    }\n\n    &__header {\n      display: flex;\n      flex-direction: row !important;\n      flex-flow: row wrap;\n      flex-shrink: 0; // Don't shrink the header\n\n      >div {\n        box-sizing: border-box;\n      }\n\n      textarea,\n      select {\n        width: 100%;\n        box-sizing: border-box;\n        border: 1px solid #464646;\n        border-radius: 2px;\n        background-color: var(--primary-color-light-500);\n        color: var(--primary-color-dark-700);\n        padding: 8px 12px;\n        height: 38px;\n        font-size: 14px;\n        line-height: 18px;\n        outline: none;\n        box-shadow: none;\n      }\n\n      textarea {\n        resize: none;\n        min-height: 38px;\n      }\n\n      textarea:focus,\n      select:focus {\n        border-color: var(--primary-color-600);\n      }\n    }\n\n    &__checkboxes {\n      position: relative;\n      width: fit-content;\n      min-width: 330px;\n      block-size: fit-content;\n      padding: 0 0 0 0;\n      border-radius: 10px;\n      margin-right: 30px;\n      margin-bottom: 10px;\n      flex-direction: row !important;\n      vertical-align: top;\n      flex-flow: row wrap;\n      align-items: center;\n      gap: 10px;\n      display: grid !important;\n      grid-auto-flow: column;\n\n      @media screen and (max-width: 426px) {\n        margin-right: 0;\n      }\n    }\n\n    &__checkbox {\n      float: left;\n\n      select {\n        width: 100%;\n      }\n\n      .a-circle-checkbox {\n        margin: 2px 0 1% !important;\n      }\n    }\n\n    &__option {\n      float: left;\n      padding-top: 8px;\n      padding-bottom: 8px;\n    }\n\n    &__history-input {\n      float: left;\n      margin: 0 15px 10px 15px;\n      border-radius: 10px;\n      border: 1px solid #e4e4e7;\n      padding: 8px 12px 8px 12px;\n      cursor: pointer;\n    }\n\n    &__history-container {\n      flex-grow: 1;\n      flex: 1;\n      min-height: 0; // RE-ADDED: Critical for scrollbar to appear\n      margin: 15px 0 15px -70px;\n      overflow-y: auto;\n      overflow-x: clip; // Use clip instead of hidden to allow tooltip overflow\n      padding-right: 20px;\n      padding-left: 70px; // Add left padding for tooltip visibility\n      max-width: calc(100% + 70px);\n\n      // Reduce margins/padding on small screens to prevent content clipping\n      @media screen and (max-width: 768px) {\n        margin: 15px 0 15px -20px;\n        padding-left: 20px;\n        padding-right: 15px;\n        max-width: calc(100% + 20px);\n      }\n\n      @media screen and (max-width: 480px) {\n        margin: 15px 0 15px -5px;\n        padding-left: 8px;\n        padding-right: 16px;\n        max-width: calc(100% + 5px);\n      }\n\n      a {\n        border-color: var(--accent-color-1);\n        color: var(--accent-color-1);\n\n        &:hover {\n          opacity: .7;\n        }\n      }\n\n      // Ensure tables and content don't cause overflow\n      table {\n        width: 100%;\n        max-width: 100%;\n        table-layout: fixed; // Equal column widths\n        word-wrap: break-word;\n        overflow-wrap: break-word;\n        border-collapse: collapse;\n\n        th,\n        td {\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          text-overflow: ellipsis;\n          vertical-align: top;\n        }\n\n        // Responsive font sizing for small screens\n        @media screen and (max-width: 768px) {\n          font-size: 0.8em;\n\n          th,\n          td {\n            padding: 3px 4px;\n          }\n        }\n\n        @media screen and (max-width: 480px) {\n          font-size: 0.7em;\n\n          th,\n          td {\n            padding: 2px 3px;\n          }\n        }\n      }\n\n      img {\n        max-width: 100%;\n        height: auto;\n      }\n\n      pre,\n      code {\n        max-width: 100%;\n        overflow-x: auto;\n        white-space: pre-wrap;\n        word-wrap: break-word;\n      }\n    }\n\n    &__input-container {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n    }\n\n    &__presentation-button-group {\n      position: absolute;\n      left: 15px;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: 10;\n      width: clamp(160px, 24vw, 200px);\n      max-width: 200px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n\n      .ui-dropdown {\n        width: 100%;\n        min-width: 100%;\n        display: flex;\n        align-items: center;\n      }\n\n      .ui-dropdown-button {\n        padding: 4px 8px;\n        font-size: 0.875rem;\n        height: auto;\n        min-height: 28px;\n        line-height: 1.2;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .ui-dropdown-menu {\n        left: 0 !important;\n        right: auto !important;\n        min-width: 100% !important;\n        width: 100% !important;\n        max-width: 100% !important;\n        box-sizing: border-box !important;\n        transform-origin: top left !important;\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n        padding: 0 !important;\n\n        &__item {\n          padding-left: 12px !important;\n          padding-right: 12px !important;\n        }\n\n        &.align-right {\n          left: auto !important;\n          right: 0 !important;\n          transform-origin: top right !important;\n        }\n      }\n\n      @media screen and (max-width: 768px) {\n        left: 10px;\n        width: auto;\n        max-width: none;\n\n        .ui-dropdown {\n          min-width: auto;\n        }\n\n        .ui-dropdown-menu {\n          min-width: 100px !important;\n          width: max-content !important;\n          max-width: none !important;\n        }\n\n        .ui-dropdown-button {\n          padding: 3px 6px;\n          font-size: 0.8rem;\n          min-height: 24px;\n        }\n      }\n    }\n\n    &__icon {\n      position: absolute;\n      right: 30px;\n      cursor: pointer;\n      height: 24px;\n    }\n\n    &__icon--enhance {\n      right: 65px;\n      color: var(--accent-color-1);\n    }\n\n    &__icon--loading {\n      cursor: default;\n      opacity: 0.5;\n      pointer-events: none;\n    }\n\n    &__input {\n      resize: none;\n      border-radius: 0 0 10px 10px;\n      padding-right: 50px;\n      padding-left: 15px;\n    }\n\n    &__input-container.has-presentation-button {\n      .research__form__input {\n        // Padding will be set dynamically via JavaScript\n        // This is just a fallback value\n        padding-left: 60px;\n      }\n    }\n\n    &__autocomplete {\n      border-radius: 10px;\n      padding: 5px 15px;\n\n      &:hover {\n        background-color: var(--primary-color-light-200);\n      }\n\n      color: var(--primary-color-600);\n      cursor: pointer;\n    }\n\n    &__autocomplete-box {\n      position: absolute;\n      bottom: 100%;\n      width: 100%;\n      left: 0;\n      background-color: var(--primary-color-light-500);\n      border: 2px solid #464646;\n      border-radius: 10px 10px 0 0;\n      border-bottom: 0;\n      z-index: var(--z-index-popup-light);\n      max-height: 500px;\n      overflow-y: auto;\n    }\n\n    &__history {\n      position: relative;\n      border-radius: 10px;\n      padding: 5px 15px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--primary-color-light-200);\n      }\n\n      &__button {\n        @media screen and (max-width: 425px) {\n          width: 36px !important;\n          height: 36px !important;\n          min-height: 36px;\n          border-radius: 50%;\n          padding: 0;\n\n          .ui-button__text {\n            display: none;\n          }\n        }\n\n        .research__form__history__button-text {\n          @media screen and (max-width: 425px) {\n            display: none;\n          }\n        }\n      }\n    }\n\n    &__user {\n      width: 100%;\n      padding: 15px 15px;\n      margin-left: auto;\n      border-width: 1;\n      border-radius: 10px;\n      display: inline-block !important;\n    }\n\n    &__followup-box {\n      display: inline-block !important;\n      vertical-align: top;\n      max-width: 50%;\n      float: right;\n      margin-left: auto;\n      color: var(--primary-color-500);\n    }\n\n    &__followup_desc {\n      margin-bottom: 10px;\n      width: fit-content;\n      padding: 5px 10px;\n      margin-left: auto;\n      margin-left: 15px;\n    }\n\n    &__followup {\n      margin-bottom: 10px;\n      width: fit-content;\n      padding: 5px 10px;\n      // margin-left: 55px;\n      margin-left: auto;\n      cursor: pointer;\n      border-radius: 10px;\n      border: 1px solid #ececf1;\n      background-color: var(--primary-color-light-500);\n      margin-left: 15px;\n\n      &:hover {\n        background-color: var(--primary-color-light-200);\n        color: var(--primary-color-500);\n      }\n    }\n\n    &__followup-category {\n      width: fit-content;\n\n      &-title {\n        padding: 5px 10px;\n        margin-bottom: 10px;\n      }\n    }\n\n    &__assistant {\n      width: 100%;\n      padding: 15px 15px;\n      border-width: 1;\n      border-radius: 10px;\n      margin-bottom: 15px;\n      display: block !important;\n    }\n\n    &__message {\n      display: block !important;\n      padding-left: 45px;\n      max-width: 100%;\n      overflow-x: hidden;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n\n      @media screen and (max-width: 768px) {\n        padding-left: 0;\n      }\n\n\n      img {\n        padding-top: 15px;\n        padding-bottom: 15px;\n        cursor: pointer;\n        max-width: 100%;\n        height: auto;\n        // Prevent shaking during streaming by reserving space for images\n        min-height: 200px;\n        object-fit: contain;\n        contain: layout;\n\n        &:hover {\n          opacity: 0.9;\n        }\n\n        // Remove min-height for small inline icons/images\n        &[width],\n        &[height] {\n          min-height: auto;\n        }\n      }\n\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        font-weight: unset;\n      }\n\n      // Responsive tables\n      table {\n        max-width: 100%;\n        width: 100%;\n        table-layout: fixed; // Equal column widths\n        word-wrap: break-word;\n        overflow-wrap: break-word;\n        border-collapse: collapse;\n\n        th,\n        td {\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          text-overflow: ellipsis;\n          vertical-align: top;\n          padding: 4px 6px;\n        }\n\n        @media screen and (max-width: 768px) {\n          font-size: 0.8em;\n\n          th,\n          td {\n            padding: 3px 4px;\n          }\n        }\n\n        @media screen and (max-width: 480px) {\n          font-size: 0.7em;\n\n          th,\n          td {\n            padding: 2px 3px;\n          }\n        }\n      }\n    }\n\n    &__row {\n      display: block !important;\n    }\n\n    &__description {\n      display: inline-block !important;\n      background-color: var(--primary-color-light-200);\n      color: var(--primary-color-500);\n      border-radius: 10px;\n      padding: 25px;\n      vertical-align: top;\n      width: fit-content;\n      max-width: 50%;\n    }\n\n    &__short-description {\n      display: inline-block !important;\n      padding: 25px;\n      color: var(--primary-color-500);\n    }\n\n    &__speaker {\n      display: inline-block !important;\n      font-weight: bold;\n      padding-left: 12px;\n      vertical-align: middle;\n    }\n\n    &__typing {\n      display: block !important;\n      width: fit-content;\n      padding: 15px 20px;\n      border-width: 1;\n      border-radius: 10px;\n      background-color: var(--primary-color-light-200);\n      min-height: 52px;\n      float: left;\n    }\n\n    &__expand {\n      padding-bottom: 15px;\n      padding-left: 45px;\n      border-width: 1;\n      border-radius: 10px;\n      flex-direction: row !important;\n\n      button {\n        margin-right: 20px;\n        margin-top: 30px;\n      }\n    }\n\n    button:not(.ui-button) {\n      border-radius: 10px;\n      float: right;\n    }\n\n    &__image {\n      width: 31px;\n      height: 31px;\n      border-radius: 50%;\n      display: inline-flex !important;\n      vertical-align: middle;\n      justify-content: center;\n\n      img {\n        display: inline-block !important;\n        width: 31px;\n        height: auto;\n        object-fit: contain;\n      }\n    }\n  }\n\n  &__table {\n    width: 100%;\n\n    @media (min-width: 1200px) {\n      background-color: var(--primary-color-light-500);\n      border-radius: 30px;\n      padding: 30px 30px;\n      margin-bottom: 100px;\n    }\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    padding: 30px 30px;\n    bottom: 0;\n\n    &__content {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 30px;\n      padding: 10px 20px;\n      background-color: var(--primary-color-light-500);\n      box-shadow: 2px 2px 6px 1px rgba(0, 0, 0, 0.17);\n      font-size: 14px;\n      font-weight: 500;\n\n      @media (min-width: 992px) {\n        font-size: 18px;\n      }\n\n      span {\n        background-color: var(--accent-color-1);\n        color: var(--primary-color-light-500);\n        font-size: 16px;\n        font-weight: 500;\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-right: 10px;\n      }\n    }\n\n    &__button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 20px;\n      background-color: var(--primary-color-600);\n      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n      border: 1px solid var(--primary-color-600);\n      color: var(--primary-color-light-500);\n      font-family: var(--tertiary-font);\n      font-size: 13px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 16px;\n      padding: 10px 20px;\n      margin-left: 10px;\n      margin-top: 0;\n\n      @media (min-width: 992px) {\n        font-size: 20px;\n        font-weight: 500;\n        letter-spacing: 0;\n        line-height: 25px;\n      }\n\n      &:hover,\n      &:focus {\n        background-color: var(--primary-color-light-500);\n        border: 1px solid var(--primary-color-600);\n        color: var(--primary-color-600);\n        transition: .4s;\n      }\n\n      i {\n        margin-left: 5px;\n        font-size: 20px;\n      }\n    }\n  }\n\n  &__checkbox {\n    margin-top: 8px;\n  }\n\n  $dot-width: 8px;\n  $dot-color: #3b5998;\n  $speed: 1.5s;\n\n  .typing-message {\n    width: fit-content;\n    display: inline-block !important;\n    vertical-align: middle;\n  }\n\n  .typing-message--pinned {\n    font-weight: 600;\n    margin-bottom: 4px;\n    opacity: 0.85;\n  }\n\n  .typing {\n    position: relative;\n    margin-left: 10px;\n    width: 42px;\n    display: inline-flex !important;\n    font-weight: bold;\n    // padding-left: 12px;\n    vertical-align: middle;\n    height: 24px;\n    align-items: center;\n\n    span {\n      content: '';\n      animation: blink $speed infinite;\n      animation-fill-mode: both;\n      height: $dot-width;\n      width: $dot-width;\n      background: $dot-color;\n      position: absolute;\n      left: 0;\n      border-radius: 50%;\n\n      &:nth-child(2) {\n        animation-delay: .2s;\n        margin-left: $dot-width * 1.5;\n      }\n\n      &:nth-child(3) {\n        animation-delay: .4s;\n        margin-left: $dot-width * 3;\n      }\n    }\n  }\n\n  @keyframes blink {\n    0% {\n      opacity: .1;\n    }\n\n    20% {\n      opacity: 1;\n    }\n\n    100% {\n      opacity: .1;\n    }\n  }\n\n  input::-webkit-calendar-picker-indicator {\n    cursor: pointer;\n  }\n\n  .data-source {\n    overflow: auto;\n    max-height: 300px;\n    margin: 20px 30px;\n    padding: 5px 10px;\n    border: 1px solid var(--primary-color-600);\n\n    .data-source__copy {\n      position: absolute;\n      top: 6px;\n      right: 10px;\n      z-index: 1;\n      padding: 2px 10px;\n      font-size: 12px;\n      line-height: 1.4;\n      color: var(--primary-color-600);\n      background: #fff;\n      border: 1px solid var(--primary-color-600);\n      border-radius: 4px;\n      cursor: pointer;\n\n      &:hover {\n        background: var(--primary-color-600);\n        color: #fff;\n      }\n    }\n  }\n\n}\n\ninput[type=date] {\n  font-size: 14px;\n  width: 130px;\n  padding-right: 0px;\n  padding-left: 40px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  border-width: 0px;\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  caret-color: transparent;\n\n  @media screen and (max-width: 426px) {\n    max-width: 45px;\n  }\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  width: 0px;\n}\n\ninput::-webkit-datetime-edit-year-field:focus {\n  background-color: transparent;\n  color: #323232\n}\n\ninput::-webkit-datetime-edit-month-field:focus {\n  background-color: transparent;\n  color: #323232\n}\n\ninput::-webkit-datetime-edit-day-field:focus {\n  background-color: transparent;\n  color: #323232\n}\n\n.half-empty {\n  height: 8px;\n}\n\n.typing-message-wrapper {\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  margin-bottom: 100px;\n  padding-left: 65px;\n}\n\n.presentation-slide {\n  margin-bottom: 4px;\n\n  h2 {\n    color: var(--primary-color-dark-900);\n    margin-bottom: 15px;\n    font-size: 1.5rem;\n  }\n\n  .slide-content {\n    margin-bottom: 4px;\n    line-height: 1.6;\n\n    &:last-child,\n    p:last-child {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  .slide-visual-section {\n    background-color: var(--background-color-light);\n    border-radius: 8px;\n    padding: 16px;\n    margin-top: 10px;\n\n    h3 {\n      color: var(--primary-color-500);\n      margin-bottom: 15px;\n      font-size: 1.2rem;\n    }\n  }\n}\n\n// On the /share page only (.research--share), the download button's tooltip sits inside\n// .chat-content, which has `overflow-x: hidden` (ChatContentView.scss) with no buffer room -\n// unlike .research__form__history-container's own clip boundary, which already carries a\n// deliberate 70px buffer for exactly this kind of overflow (see its negative-margin/padding\n// rule above). Centered on a button this close to chat-content's edge, the tooltip's left\n// half falls outside that boundary and gets clipped; there isn't enough room to center it\n// without clipping unless chat-content stops clipping it. :has() scopes this to only the\n// chat-content blocks that actually contain this button, so other content still gets\n// chat-content's normal overflow protection. With this in place, IconButton.scss's own\n// default centering (left: 50%; transform: translateX(-50%)) already renders correctly - no\n// override or JS positioning needed.\n.research--share .chat-content:has(.download-presentation-btn) {\n  overflow-x: visible;\n}\n\n.slide-visual-suggestion {\n  img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    // Prevent shaking during streaming\n    min-height: 200px;\n    object-fit: contain;\n    contain: layout;\n\n    &:hover {\n      opacity: 0.9;\n    }\n  }\n\n  .visual-analysis {\n    margin-top: 15px;\n\n    p {\n      margin-bottom: 12px;\n      line-height: 1.5;\n\n      strong {\n        color: var(--primary-color-dark-900);\n        display: block;\n        margin-bottom: 5px;\n      }\n    }\n\n    .visual-source {\n      font-size: 0.9rem;\n      color: var(--text-color-secondary);\n      margin-top: 10px;\n\n      a {\n        color: var(--primary-color-500);\n        text-decoration: none;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n.sidenav.share-layout {\n  overflow-y: hidden !important;\n  height: 100vh;\n  max-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n// Inline chart styles for streaming charts inserted during report generation\n.inline-chart-container {\n  position: relative;\n  margin: 20px 0;\n  padding: 15px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 12px;\n  border-left: 4px solid var(--primary-color-500, #4a90d9);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  // Prevent shaking during streaming by containing layout changes\n  contain: layout style;\n  // Reserve minimum space for chart content\n  min-height: 250px;\n\n  // Hide charts that have been hidden by user\n  &[data-hidden=\"true\"] {\n    display: none !important;\n  }\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  }\n\n  img.inline-report-chart {\n    max-height: 400px;\n    max-width: 100%;\n    border-radius: 8px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    display: block;\n\n    &:hover {\n      opacity: 0.9;\n    }\n  }\n\n  .inline-chart-analysis {\n    font-size: 14px;\n    line-height: 1.6;\n    color: var(--primary-color-dark-700, #333);\n\n    p {\n      margin: 8px 0;\n\n      strong {\n        color: var(--primary-color-dark-900, #1a1a1a);\n        display: block;\n        margin-bottom: 4px;\n      }\n    }\n\n    a {\n      color: var(--primary-color-500, #4a90d9);\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .delete-chart-btn {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 4px 8px;\n    cursor: pointer;\n    font-size: 11px;\n    z-index: 10;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.7);\n    }\n  }\n\n  // Responsive adjustments\n  @media screen and (max-width: 768px) {\n    padding: 12px;\n    margin: 15px 0;\n\n    img.inline-report-chart {\n      max-height: 300px;\n    }\n\n    .inline-chart-analysis {\n      font-size: 13px;\n    }\n\n    .delete-chart-btn {\n      opacity: 1;\n    }\n  }\n\n  @media screen and (max-width: 480px) {\n    padding: 10px;\n    margin: 12px 0;\n    border-radius: 8px;\n\n    img.inline-report-chart {\n      max-height: 250px;\n      margin-bottom: 8px;\n    }\n\n    .inline-chart-analysis {\n      font-size: 12px;\n\n      p {\n        margin: 6px 0;\n      }\n    }\n  }\n}\n\n// Hide delete button in share mode (shared links)\n.share-layout {\n  .delete-chart-btn {\n    display: none !important;\n  }\n}\n\n.trusted-sources-footer {\n  margin-top: 24px;\n  padding: 20px 24px;\n  background: linear-gradient(to right, rgba(59, 130, 246, 0.08), rgba(59, 130, 246, 0.02));\n  border-left: 4px solid #3b82f6;\n  border-radius: 12px;\n  font-family: var(--primary-font);\n  color: #1e293b;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n  width: fit-content;\n  max-width: 100%;\n\n  @media screen and (max-width: 480px) {\n    padding: 15px 16px;\n  }\n\n  .trusted-sources-header {\n    font-weight: 700;\n    font-size: 1.1em;\n    margin-bottom: 14px;\n    color: #0f172a;\n    position: relative;\n    padding-left: 32px;\n    line-height: 1.5;\n\n    &::before {\n      content: '✓';\n      position: absolute;\n      left: 0;\n      top: 2px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 20px;\n      height: 20px;\n      background-color: #3b82f6;\n      color: white;\n      border-radius: 50%;\n      font-size: 11px;\n      font-weight: 900;\n      box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n    }\n  }\n\n  .trusted-sources-list {\n    list-style-type: none;\n    padding-left: 0;\n    margin: 0;\n\n    li {\n      position: relative;\n      padding-left: 32px;\n      margin-bottom: 10px;\n      line-height: 1.6;\n      font-size: 0.95em;\n      color: #334155;\n\n      &::before {\n        content: \"•\";\n        color: #60a5fa;\n        font-weight: bold;\n        font-size: 1.2em;\n        position: absolute;\n        left: 10px;\n        top: -1px;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      a {\n        color: #2563eb;\n        font-weight: 600;\n        text-decoration: none;\n        transition: color 0.15s ease;\n        border-bottom: 1px dotted rgba(37, 99, 235, 0.3);\n\n        &:hover {\n          color: #1e40af;\n          text-decoration: none;\n          border-bottom: 1px solid #1e40af;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
